// import React, { useState } from "react";
import React, { useEffect, useRef, useState } from "react";

import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link } from "react-router-dom";
import { createEmailTemplate, createPackageApi, createPickupDeliveryAddressAdminApi, createShipmentOrderApi, createUserAdminApi, createUserLocationApi, getInsuranceChargeApi, getInsuranceChargesApi, getOrderAllUsersApi, getOrderCategories, getOrderCategoriesApi, getOrderDeliveryAddressApi, getOrderPackageSizesApi, getOrderPickupAddressApi, getOrderSubCategoriesApi, getPackageSizeApi, getShipChargesApi, getSubCategoriesApi, getUserLocationsApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";
import CreateUser from "./CreateUser";
import CreateDeliveryAddress from "./CreateDeliveryAddress";
import CreatePickupAddress from "./CreatePickupAddress";
import Select from 'react-select';

import useGooglePlacesAutocomplete from "../../hook/useGooglePlacesAutocomplete";
const AddOrderV3 = () => {







    const initialFormData = {
        fullName: "",

        email: "",
        password: "",
        countryCode: "",
        mobile: "",
    };

    const initialFormErrors = {
        fullName: "",

        email: "",
        password: "",
        countryCode: "",
        mobile: "",
    };


    const initialPickUpData = {
        fullName: "",
        countryCode: "",
        mobile: "",
        state: "",
        city: "",
        zipCode: "",
        address: "",
        landmark: "",
        saveAs: "",
        areaName: "",
        buildingNo: "",
        addressLine2: "",
    };

    const initialPickUpErrors = {
        fullName: "",
        countryCode: "",
        mobile: "",
        state: "",
        city: "",
        zipCode: "",
        address: "",
        landmark: "",
        saveAs: "",
        areaName: "",
        buildingNo: "",
        addressLine2: "",


    };





    const [discountError, setDiscountError] = useState("");

    // let { user } = useSelector(state => state.authModal)
    const [customLength, setCustomLength] = useState('');
    const [customWidth, setCustomWidth] = useState('');
    const [customHeight, setCustomHeight] = useState('');
    const [selectedOrderPackage, setSelectedOrderPackage] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState(initialFormErrors);

    const [customWeight, setCustomWeight] = useState("");
    // const [customWeight, setCustomWeight] = useState("");
    const [customDimensions, setCustomDimensions] = useState("");
    const [customDimensionUnit, setCustomDimensionUnit] = useState("inch");
    const [isInch, setIsInch] = useState(true)
    const [paymentStatus, setPaymentStatus] = useState("MARK_PAID");

    // const [customDimensionUnit, setCustomDimensionUnit] = useState("inch");

    // const [customDimensions, setCustomDimensions] = useState("");

    const [pickupFormData, setPickupFormData] = useState(initialPickUpData);
    const [pickupFormErrors, setPickupFormErrors] = useState(initialPickUpErrors);


    const [amountToBePaid, setAmountToBePaid] = useState(0);

    //   const [shipmentCharges, setShipmentCharges] = ([]);

    const [additionalProperties, setAdditionalProperties] = useState(null);
    const [insuranceCharges, setInsuranceCharges] = useState([]);
    const [insuranceAmount, setInsuranceAmount] = useState()



    console.log("Insurance MAount", insuranceAmount)

    const handlePickupChange = (e) => {
        const { name, value } = e.target;
        setPickupFormData(prev => ({ ...prev, [name]: value }));

        // Real-time basic validation
        if (value.trim() === "") {
            setPickupFormErrors(prev => ({ ...prev, [name]: "This field is required" }));
        } else {
            setPickupFormErrors(prev => ({ ...prev, [name]: "" }));
        }
    };


    // const fullName = `${formData?.firstName || ""} ${formData?.lastName || ""}`.trim();




    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "fullName":

                if (!value.trim()) error = "This field is required.";
                break;
            case "email":
                if (!value) error = "Email is required.";
                else if (!/^\S+@\S+\.\S+$/.test(value)) error = "Invalid email.";
                break;
            case "password":
                if (!value) error = "Password is required.";
                else if (value.length < 6) error = "Minimum 6 characters.";
                break;
            case "mobile":
                if (!value) error = "Mobile is required.";
                else if (!/^\d{10}$/.test(value)) error = "Enter 10-digit number.";
                break;
            case "countryCode":
                if (!value) error = "Select country code.";
                break;
            default:
                break;
        }

        setFormErrors((prev) => ({ ...prev, [name]: error }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);




    };



    const handleCreatePickUpAddress = async (e) => {
        e.preventDefault();

        // Validate all fields before submission
        // Object.entries(formData).forEach(([name, value]) =>
        //     validateField(name, value)
        // );

        // const isFormValid = Object.values(formErrors).every((e) => !e);
        // if (isFormValid) {
        // console.log("Form submitted:", formData);

        // createPickupDeliveryAddressAdminApi
        try {
            const data = await createUserLocationApi({


                address: `${pickupFormData?.address || ""}, ${pickupFormData?.addressLine2 || ""}, ${pickupFormData?.zipCode || ""}, ${pickupFormData?.city || ""}, ${pickupFormData?.state || ""}`,
                city: pickupFormData?.city, fullname: pickupFormData?.fullName, mobile_number: pickupFormData?.mobile, mobile_number_country_code: pickupFormData?.countryCode, saveThis: true, state: pickupFormData?.city, user_id: userId, zipcode: pickupFormData?.zipCode, saveAs: pickupFormData?.saveAs, landmark: pickupFormData?.addressLine2, isPickup: true, from: fromCountry, area_name: pickupFormData?.address
            });
            console.log(data)

            setPickupFormData(initialPickUpData)

            // const data = await createUserLocationApi({
            //                 address: `${pickupFormData?.address || ""}, ${pickupFormData?.addressLine2 || ""}, ${pickupFormData?.zipCode || ""}, ${pickupFormData?.city || ""}, ${pickupFormData?.state || ""}`,
            //                 city: pickupFormData?.city, fullname: pickupFormData?.fullName, mobile_number: pickupFormData?.mobile, mobile_number_country_code: pickupFormData?.countryCode, saveThis: true, state: pickupFormData?.city, user_id: userId, zipcode: pickupFormData?.zipCode, saveAs: pickupFormData?.saveAs, landmark: pickupFormData?.addressLine2, isPickup: false, from: toCountry, area_name: pickupFormData?.address
            //             });


            const modalEl = document.getElementById('addPickup');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            // setOrderUsers(data)

            // setOrderCategories(data?.categories)
            toast.success("Address Created Successfully");
            // getUserDeliveryAddress()
            // getUserPickupAddress()
            getUserPickupLocation()
        } catch (err) {
            console.error("Fetch Error:", err);


            toast.error(
                err || "Something went wrong while creating user",

            );
        } finally {

        }
        // } else {
        console.log("Fix form errors first.");
        // }
    };


    const handleCreateDeliveryAddress = async (e) => {
        e.preventDefault();


        try {
            const data = await createUserLocationApi({
                address: `${pickupFormData?.address || ""}, ${pickupFormData?.addressLine2 || ""}, ${pickupFormData?.zipCode || ""}, ${pickupFormData?.city || ""}, ${pickupFormData?.state || ""}`,
                city: pickupFormData?.city, fullname: pickupFormData?.fullName, mobile_number: pickupFormData?.mobile, mobile_number_country_code: pickupFormData?.countryCode, saveThis: true, state: pickupFormData?.city, user_id: userId, zipcode: pickupFormData?.zipCode, saveAs: pickupFormData?.saveAs, landmark: pickupFormData?.addressLine2, isPickup: false, from: toCountry, area_name: pickupFormData?.address
            });
            console.log(data)

            setPickupFormData(initialPickUpData)





            const modalEl = document.getElementById('addDelivery');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            // setOrderUsers(data)

            // setOrderCategories(data?.categories)
            toast.success("Address Created Successfully");
            // getUserDeliveryAddress()
            getUserDeliveryLocation()
            // getUserPickupAddress()
        } catch (err) {
            console.error("Fetch Error:", err);


            toast.error(
                err || "Something went wrong while creating user",

            );
        } finally {

        }
        // } else {
        console.log("Fix form errors first.");
    };


    const handleCreateUser = async (e) => {
        e.preventDefault();

        // Validate all fields before submission
        Object.entries(formData).forEach(([name, value]) =>
            validateField(name, value)
        );

        const isFormValid = Object.values(formErrors).every((e) => !e);
        if (isFormValid) {
            console.log("Form submitted:", formData);
            try {
                const data = await createUserAdminApi({ country_code: formData?.countryCode, email: formData?.email, fullname: formData?.fullName, mobilenumber: formData?.mobile, password: formData?.password });
                console.log(data)
                toast.success("Password setup link sent to the user's email.")

                getOrderAllUsers()
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    password: "",
                    countryCode: "",
                    mobile: "",

                })




                const modalEl = document.getElementById('exampleModal');
                const modalBackdrop = document.querySelector('.modal-backdrop');

                modalEl.classList.remove('show');
                modalEl.style.display = 'none';
                modalEl.setAttribute('aria-hidden', 'true');

                if (modalBackdrop) modalBackdrop.remove();
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
                // setOrderUsers(data)

                // setOrderCategories(data?.categories)
                // toast.success("Email Templates fetched successfully!", { id: toastId });
            } catch (err) {
                console.error("Fetch Error:", err);


                toast.error(
                    err || "Failed to send the invitation. Please try again.",

                );
            } finally {

            }
        } else {
            console.log("Fix form errors first.");
        }
    };



    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedPackage } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    const [categoryId, setCategoryId] = useState("")
    const [subCategoryId, setSubCategoryId] = useState("")
    const [userId, setUserId] = useState("")
    const [pickupId, setPickupId] = useState("")
    const [deliveryId, setDeliveryId] = useState("")

    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [categoryIds, setCategoryIds] = useState([]);

    const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState([]);
    const [subCategoryIds, setSubCategoryIds] = useState([]);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);






    const [sizeName, setSizeName] = useState('');

    const [sizeLength, setSizeLength] = useState('');
    const [sizeWidth, setSizeWidth] = useState('');
    const [sizeHeight, setSizeHeight] = useState('');
    const [sizeWeight, setSizeWeight] = useState('');
    const [discount, setDiscount] = useState('');

    const [additionalDiscount, setAdditionalDiscount] = useState()
    const [insuranceValue, setInsuranceValue] = useState()


    const [loading, setLoading] = useState(false)
    const [shipmentShip, setShipmentShip] = useState('');
    const [shipmentAir, setShipmentAir] = useState('');
    const [ecomShip, setEcomShip] = useState('');
    const [ecomAir, setEcomAir] = useState('');
    const [orderCategories, setOrderCategories] = useState()
    const [orderSubCategories, setOrderSubCategories] = useState()
    const [orderUsers, setOrderUsers] = useState()
    const [orderPackage, setOrderPackage] = useState()
    const [orderDeliveryAddress, setOrderDeliveryAddress] = useState([])
    const [orderPickupAddress, setOrderPickupAddress] = useState()

    const [pickupDate, setPickupDate] = useState("");
    const [pickupTime, setPickupTime] = useState("");
    const [pickupType, setPickupType] = useState("");
    const [dueDateTime, setDueDateTime] = useState("");

    // console.log("Selected Package :",orderPackage)


    console.log("Selected Pckage", selectedOrderPackage)


    const [selectedUnit, setSelectedUnit] = useState("Inch");


    const [selectedShipType, setSelectedShipType] = useState("");
    const isSelected = (type) => selectedShipType === type;
    const [selectedDiscountType, setSelectedDiscountType] = useState("");
    const [shipCharges, setShipCharges] = useState([])




    const [subject, setSubject] = useState('');






    // const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [packageId, setPackageId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');

    const [shipmentCharges, setShipmentCharges] = useState([]);



    const getOrderCategories = async () => {






        try {
            const data = await getOrderCategoriesApi();

            setOrderCategories(data?.categories)

        } catch (err) {
            console.error("Fetch Error:", err);


        } finally {

        }
    };




    const getShipAllCharges = async () => {






        try {
            const res = await getShipChargesApi();
            setShipCharges(res?.data || [])



        } catch (err) {
            console.error("Fetch Error:", err);


        } finally {

        }
    };


    useEffect(() => {
        if (selectedShipType) {

            getShipAllCharges()
        }

    }, [selectedShipType])


    const currentShipCharges = shipCharges.find(
        (charge) => charge.shipping_charges_type === selectedShipType
    ) || {};





    // console.log("Ship Charges:", currentShipCharges)




    // async function getOrderSubCategories() {





    //     try {
    //         const data = await getOrderSubCategoriesApi({ category_id: categoryId });
    //         console.log(data);
    //         setOrderSubCategories(data);


    //     } catch (err) {
    //         console.error("Fetch Error:", err);


    //     } finally {
    //     }
    // }
    async function getOrderSubCategories(categoryId) {
        try {
            const data = await getOrderSubCategoriesApi({ category_id: categoryId });
            setOrderSubCategories(data);
        } catch (err) {
            console.error("Fetch Error:", err);
        }
    }



    const getOrderAllUsers = async () => {






        try {
            const data = await getOrderAllUsersApi();
            console.log(data)
            setOrderUsers(data || [])


        } catch (err) {
            console.error("Fetch Error:", err);

        } finally {

        }
    };



    const getOrderPackageSizes = async () => {






        try {
            const data = await getOrderPackageSizesApi();
            console.log(data)
            // setOrderUsers(data)\\

            setOrderPackage(data?.packageSizes)
            setShipmentCharges(data?.shipmentCharges || [])
            setInsuranceCharges(data?.insuranceCharges || [])


        } catch (err) {
            console.error("Fetch Error:", err);


        } finally {

        }
    };




    // const getUserDeliveryAddress = async () => {






    //     try {
    //         const data = await getOrderDeliveryAddressApi({ user_id: userId });
    //         console.log(data)


    //         setOrderDeliveryAddress(data || [])


    //     } catch (err) {
    //         console.error("Fetch Error:", err);


    //     } finally {

    //     }
    // };

    // const getUserPickupAddress = async () => {






    //     try {
    //         const data = await getOrderPickupAddressApi({ user_id: userId });
    //         console.log(data)
    //         setOrderPickupAddress(data || [])

    //     } catch (err) {
    //         console.error("Fetch Error:", err);


    //     } finally {

    //     }
    // };



    const getUserPickupLocation = async () => {




        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const res = await getUserLocationsApi({ user_id: userId, from: fromCountry });
            // console.log(data)
            setOrderPickupAddress(res?.data || [])

        } catch (err) {
            console.error("Fetch Error:", err);


        } finally {

        }
    };



    const getUserDeliveryLocation = async () => {




        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const res = await getUserLocationsApi({ user_id: userId, from: toCountry });
            // console.log(data)
            setOrderDeliveryAddress(res?.data || [])

        } catch (err) {
            console.error("Fetch Error:", err);


        } finally {

        }
    };




    useEffect(() => {

        getOrderAllUsers()
        getOrderPackageSizes()






    }, [])

    useEffect(() => {

        if (userId) {
            getUserPickupLocation()
            getUserDeliveryLocation()

            // getUserDeliveryAddress()
            // getUserPickupAddress()

        }





    }, [userId])


    // useEffect(() => {

    //     getOrderCategories()

    //     if (categoryId) {
    //         getOrderSubCategories()
    //     }


    // }, [categoryId])

    useEffect(() => {
        getOrderCategories();

        // If one or more categories are selected, get subcategories for the first one
        if (categoryIds.length > 0) {
            const currentCategoryId = categoryIds[categoryIds.length - 1]; // last selected
            getOrderSubCategories(currentCategoryId);
        }
    }, [categoryIds]);



    const [isCreatingOrder, setIsCreatingOrder] = useState(false)



    const handleSubmit = async (e) => {
        e.preventDefault();



        setIsCreatingOrder(true)

        const formatDate = (dateStr) => {
            const [year, month, day] = dateStr.split("-");
            return `${day}-${month}-${year}`;
        };

        // Convert time from 24-hour HH:mm to 12-hour format with AM/PM
        const formatTime = (timeStr) => {
            const [hour, minute] = timeStr.split(":");
            let h = parseInt(hour);
            const ampm = h >= 12 ? "PM" : "AM";
            h = h % 12 || 12; // Convert 0 to 12 for 12 AM
            return `${h}:${minute} ${ampm}`;
        };



        const formData = new FormData();
        formData.append('shipment_type', selectedShipType);
        formData.append('delivery_address_id', deliveryId);
        formData.append('user_id', userId);
        formData.append('order_type', "SHIPMENT");
        formData.append('pickup_address_id', pickupId);
        formData.append('package_size_id', packageId === "custom" ? "" : packageId);
        // formData.append('category_id', categoryIds); 
        // formData.append('sub_category_id', subCategoryIds); 
        categoryIds.forEach((id) => {
            formData.append('category_id', id);
        });

        subCategoryIds.forEach((id) => {
            formData.append('sub_category_id', id);
        });


        formData.append('is_created_by_admin', true);
        formData.append('pickup_date', formatDate(pickupDate));
        formData.append('pickup_time', formatTime(pickupTime));
        formData.append('pickup_type', orderType);
        formData.append('order_amount', amountToBePaid);
        formData.append('insurance_value', additionalProperties?.insurance_value || 0); 
        formData.append('insurance_applied', insuranceAmount || 0);

        formData.append('payment_status', paymentStatus);
        formData.append('weight', customWeight);

        formData.append('length', customLength);
        formData.append('width', customWidth);
        formData.append('height', customHeight);
        formData.append('inch', isInch);













        formData.append('from', fromCountry);
        formData.append('to', toCountry);













        try {
            const res = await createShipmentOrderApi(formData);
            console.log('Success:', res);
            toast.success("Order Created Successfully")
            navigate("/order-management")


        } catch (err) {

            console.error('Error:', err);
        }

        finally {
            setIsCreatingOrder(false)
        }


    };



    console.log("Package", selectedPackage)


    useEffect(() => {
        if (selectedPackage) {

            setSizeName(selectedPackage?.size_name || '')
            setSizeLength(selectedPackage?.size_length || '')
            setSizeWidth(selectedPackage?.size_width || '')
            setSizeHeight(selectedPackage?.size_height || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setDiscount(selectedPackage?.discount || '')
            setSelectedUnit(selectedPackage?.inch ? "Inch" : "Feet" || '')
            setPackageId(selectedPackage?.id || '')


            // setEmailId(selectedEmailTemplate?.id || '')




            if (selectedPackage?.icon_url) {
                setImagePreview(selectedPackage.icon_url);
                const imageName = selectedPackage.icon_url
                setImageName(imageName);
                setMailImage(selectedPackage?.icon_url)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }



        }

        return () => {

            dispatch(clearSelectedPackage());
        };
    }, [selectedPackage, dispatch]);

    console.log("Selected Order Package", selectedOrderPackage)

    // console.log(mailImage)
    function getTotalFieldValue(info) {
        const local_delivery_charge = info?.local_delivery_charge
            ? info?.local_delivery_charge
            : 0;
        const international_courier_charge = info?.international_courier_charge
            ? info?.international_courier_charge
            : 0;
        const human_resource_charge = info?.human_resource_charge
            ? info?.human_resource_charge
            : 0;
        const taxes = info?.taxes ? info?.taxes : 0;
        let grandTotal = local_delivery_charge + international_courier_charge;
        if (info?.Order_charges_type === "ECOM") {
            grandTotal += human_resource_charge;
        }
        const taxAmount = (grandTotal * taxes) / 100;
        return taxAmount + grandTotal;
    }





    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };














    function calculateShipmentAmountTotal(shipType, orderType, value = 0) {
        const charges = shipmentCharges.find(
            (el) =>
                el.shipping_charges_type === shipType &&
                el.Order_charges_type === orderType
        );
        function getTotalFieldValue(info) {
            const local_delivery_charge = info?.local_delivery_charge
                ? info?.local_delivery_charge
                : 0;
            const international_courier_charge = info?.international_courier_charge
                ? info?.international_courier_charge
                : 0;
            const human_resource_charge = info?.human_resource_charge
                ? info?.human_resource_charge
                : 0;
            const taxes = info?.taxes ? info?.taxes : 0;
            let grandTotal = local_delivery_charge + international_courier_charge;
            if (info?.Order_charges_type === "ECOM") {
                grandTotal += human_resource_charge;
            }
            const taxAmount = (grandTotal * taxes) / 100;
            return taxAmount + grandTotal;
        }
        const amountWithTax = getTotalFieldValue({
            ...charges,
            Order_charges_type: orderType,
        });
        let grandTotal = amountWithTax * value;

        if (selectedOrderPackage?.discount) {
            const discountAmount = (grandTotal * selectedOrderPackage?.discount) / 100;
            grandTotal = grandTotal - discountAmount;
        }

        // setTotalAmount(grandTotal);

        if (additionalProperties?.insurance_value) {
            let insuranceTotal =
                insuranceCharges.upto_value <= additionalProperties?.insurance_value
                    ? additionalProperties?.insurance_value
                    : insuranceCharges.upto_value;
            const insurancePercent =
                (insuranceTotal * insuranceCharges.percentage_amount) / 100;
            grandTotal += insurancePercent;
        }
        if (insuranceCharges?.gst_percentage) {
            const gstPercent = (grandTotal * insuranceCharges?.gst_percentage) / 100;
            grandTotal += gstPercent;
        }

        if (additionalProperties?.additional_discount) {
            grandTotal -= additionalProperties?.additional_discount;
        }

        grandTotal = parseFloat(grandTotal.toFixed(2));
        return grandTotal;
    }


    // console.log("Additional Discount",additionalProperties?.additional_discount )

    // function calculateAmountByWeight(
    //     intlCharge,
    //     localCharge,
    //     weight,
    //     additionalDiscount = 0,
    //     insuranceFlat = 0
    // ) {
    //     if (!intlCharge || !localCharge || !weight || weight <= 0) {
    //         console.error("Invalid Input")
    //     }

    //     let baseAmount = intlCharge + localCharge;
    //     let amount = baseAmount * weight;

    //     amount -= additionalDiscount;

    //     if (insuranceFlat > 0) {
    //         amount += insuranceFlat;
    //     }
    //     console.log(amount);

    //     return parseFloat(amount?.toFixed(2));
    // }
    function calculateAmountByWeight(
        intlCharge,
        localCharge,
        weight,
        additionalDiscount = 0,
        insuranceFlat = 0
    ) {
        // Convert all inputs to numbers and validate
        const numIntlCharge = parseFloat(intlCharge) || 0;
        const numLocalCharge = parseFloat(localCharge) || 0;
        const numWeight = parseFloat(weight) || 0;
        const numAdditionalDiscount = parseFloat(additionalDiscount) || 0;
        const numInsuranceFlat = parseFloat(insuranceFlat) || 0;

        // Validate required inputs
        if (numIntlCharge <= 0 || numLocalCharge <= 0 || numWeight <= 0) {
            console.error("Invalid Input - charges and weight must be positive numbers");
            return 0; // Return 0 instead of undefined
        }

        let baseAmount = numIntlCharge + numLocalCharge;
        let amount = baseAmount * numWeight;

        amount -= numAdditionalDiscount;

        if (numInsuranceFlat > 0) {
            amount += numInsuranceFlat;
        }

        // Ensure amount is not negative
        amount = Math.max(0, amount);

        console.log('Calculated amount:', amount);

        // No need for optional chaining since amount is guaranteed to be a number
        return parseFloat(amount.toFixed(2));
    }


    //     100, // international_courier_charg
    //     23, // local_delivery_charge
    //     1, // weight in kg
    //     0, // additional discount
    //     100 // flat insurance value
    // );


    // useEffect(() => {
    //     if (
    //         currentShipCharges?.international_courier_charge &&
    //         currentShipCharges?.local_delivery_charge &&
    //         selectedOrderPackage?.size_weight > 0
    //     ) {
    //         const amount = calculateAmountByWeight(
    //             currentShipCharges.international_courier_charge,
    //             currentShipCharges.local_delivery_charge,
    //             selectedOrderPackage.size_weight,
    //             additionalProperties?.additional_discount || 0,
    //             additionalProperties?.insurance_value || 0
    //         );

    //         setAmountToBePaid(amount);
    //     } else {
    //         setAmountToBePaid(0);
    //     }
    // }, [currentShipCharges, selectedOrderPackage, additionalProperties]);

    useEffect(() => {
        const weight = packageId === "custom"
            ? parseFloat(customWeight || 0)
            : selectedOrderPackage?.size_weight || 0;

        if (
            currentShipCharges?.international_courier_charge &&
            currentShipCharges?.local_delivery_charge &&
            weight > 0
        ) {
            const amount = calculateAmountByWeight(
                currentShipCharges.international_courier_charge,
                currentShipCharges.local_delivery_charge,
                weight,
                additionalProperties?.additional_discount || 0,
                additionalProperties?.insurance_value || 0
            );

            setAmountToBePaid(amount);
        } else {
            setAmountToBePaid(0);
        }
    }, [packageId, selectedOrderPackage, customWeight, currentShipCharges, additionalProperties]);





    console.log("selected user", selectedUser)

    const [currentStep, setCurrentStep] = useState(1);
    const [orderType, setOrderType] = useState("DOORSTEP"); // Default can be "pickup" or empty


    const nextStep = () => {
        if (currentStep < 4) {
            setCurrentStep(currentStep + 1);
        }
    };

    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };



    const isStep2ButtonDisabled =
        !packageId ||
        // !pickupId ||
        !pickupDate ||
        !pickupTime ||
        // (orderType === "DOORSTEP" && !deliveryId) 

        // ||




        (orderType === "DOORSTEP" && (!pickupId || !deliveryId)) ||
        (orderType === "WAREHOUSE" && !deliveryId) ||






        (packageId === "custom" &&
            (!customWeight || !customLength || !customWidth || !customHeight));


    const isStep3ButtonDisabled = (paymentStatus === "MARK_DUE" && !dueDateTime)

    const userOptions = orderUsers?.map((user) => ({
        value: user.id,
        label: `${user.fullname} - ${user.email}`,
        shortLabel: user.fullname,
    }));

    // Find selected option based on userId
    const selectedOption = userOptions?.find((opt) => String(opt.value) === String(userId));


    //Select Categories FIeld

    const categoryOptions = orderCategories?.map((category) => ({
        value: category.id,
        label: category.name,
    }));




    const selectedCategoryOption = categoryOptions?.find(
        (option) => String(option.value) === String(categoryId)
    );

    //Select Subcategories Field

    const subCategoryOptions = orderSubCategories?.map((sub) => ({
        value: sub.id,
        label: sub.name,
    }));
    const selectedSubCategoryOption = subCategoryOptions?.find(
        (opt) => String(opt.value) === String(subCategoryId)
    );


    //Select Pick Up Address

    const pickupAddressOptions = orderPickupAddress?.map((address) => ({
        value: address.id,
        label: address.address,
    }));

    const selectedPickupOption = pickupAddressOptions?.find(
        (opt) => String(opt.value) === String(pickupId)
    );


    //Select Delivery Address


    const deliveryAddressOptions = orderDeliveryAddress?.map((address) => ({
        value: address.id,
        label: address.address,
    }));


    const selectedDeliveryOption = deliveryAddressOptions?.find(
        (opt) => String(opt.value) === String(deliveryId)
    );

    //Select Package Sizes 


    const packageSizeOptions = [
        ...orderPackage?.map((pkg) => ({
            value: pkg.id,
            label: `${pkg.size_name} - ${pkg.size_weight} KG`,
            data: pkg,
        })) || [],
        {
            value: "custom",
            label: "Custom",
        },
    ];

    const selectedPackageOption = packageSizeOptions.find(
        (opt) => String(opt.value) === String(packageId)
    );


    const getInsuranceCharges = async (insuranceValue) => {
        const payload = {
            insurance_value: insuranceValue
        };

        try {
            const data = await getInsuranceChargesApi(payload);
            setInsuranceAmount(data?.insuranceCharges);

        } catch (err) {
            console.error("Fetch Error:", err);
        }
    };

    const [percentAmount, setPercentAmount] = useState();
    const [gstPercent, setGstPercent] = useState()
    const [uptoVal, setUptoVal] = useState()

    const getInsuranceNote = async () => {

        try {
            const data = await getInsuranceChargeApi();
            // setInsuranceAmount(data?.insuranceCharges);
            setPercentAmount(data?.percentage_amount)
            setGstPercent(data?.gst_percentage)
            setUptoVal(data?.upto_value)
        } catch (err) {
            console.error("Fetch Error:", err);
        }

    }


    console.log(`${percentAmount} - ${gstPercent} - ${uptoVal}`)


    useEffect(() => {
        getInsuranceNote()


    }, [])






    // useEffect(() => {
    //     getInsuranceCharges()
    // }, [])


    console.log("Insurance Ammount", insuranceAmount)


    const [isInsuranceApplied, setIsInsuranceApplied] = useState(false);
    const [insuranceError, setInsuranceError] = useState('');
    return (


        <>
            <div className='row gy-4 my-24 justify-content-center align-items-center'>
                <div className='col-md-6 fix-height' >

                    <div className='card' style={{ borderRadius: "17px" }}>
                        <div className='card-body' style={{ padding: "30px" }}>
                            <h6 className='mb-4 text-xl'>Create Order By Following Step</h6>
                            {/* <p className='text-neutral-500'>
                            Fill up your details and proceed next steps.
                        </p> */}
                            {/* Form Wizard Start */}
                            <div className='form-wizard'>
                                <form onSubmit={handleSubmit}>
                                    <div className='form-wizard-header overflow-x-auto scroll-sm pb-8 my-32'>
                                        <ul className='list-unstyled form-wizard-list style-two'>
                                            <li
                                                className={`form-wizard-list__item
                      ${[2, 3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 1 && "active"} `}
                                            >
                                                <div className='form-wizard-list__line'>
                                                    <span className='count'>1</span>
                                                </div>
                                                <span style={{ fontSize: "17px" }} className=' fw-semibold'>
                                                    Order
                                                </span>
                                            </li>
                                            <li
                                                className={`form-wizard-list__item
                      ${[3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 2 && "active"} `}
                                            >
                                                <div className='form-wizard-list__line'>
                                                    <span className='count'>2</span>
                                                </div>
                                                <span className='  fw-semibold' style={{ fontSize: "17px" }}>
                                                    Package
                                                </span>
                                            </li>
                                            <li
                                                className={`form-wizard-list__item
                      ${[4].includes(currentStep) && "activated"}
                    ${currentStep === 3 && "active"} `}
                                            >
                                                <div className='form-wizard-list__line'>
                                                    <span className='count'>3</span>
                                                </div>
                                                <span style={{ fontSize: "17px" }} className=' fw-semibold'>Payment</span>
                                            </li>
                                            <li
                                                className={`form-wizard-list__item

                    ${currentStep === 4 && "active"} `}
                                            >
                                                <div className='form-wizard-list__line'>
                                                    <span className='count'>4</span>
                                                </div>
                                                <span className=' fw-semibold' style={{ fontSize: "17px" }}>Checkout</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <fieldset
                                        className={`wizard-fieldset ${currentStep === 1 && "show"} `}
                                    >

                                        <div className='row gy-3'>

                                            <div className="mb-4">
                                                <label className='form-label'>Select Order Type*</label>

                                                <div className="d-flex gap-3">
                                                    <button
                                                        type="button"
                                                        className="btn px-3 py-[10px] rounded "
                                                        style={{
                                                            backgroundColor: orderType === "DOORSTEP" ? "#F2F5FF" : "#ffffff",
                                                            border: orderType === "DOORSTEP" ? "1px solid #243E85" : "1px solid #F4F4F4",
                                                            color: orderType === "DOORSTEP" ? "#243E85" : "#888888",
                                                        }}
                                                        onClick={() => setOrderType("DOORSTEP")}
                                                    >
                                                        Pickup from Doorstep
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn px-3 py-[10px] rounded "
                                                        style={{
                                                            backgroundColor: orderType === "WAREHOUSE" ? "#F2F5FF" : "#ffffff",
                                                            border: orderType === "WAREHOUSE" ? "1px solid #243E85" : "1px solid #F4F4F4",
                                                            color: orderType === "WAREHOUSE" ? "#243E85" : "#888888",
                                                        }}
                                                        onClick={() => setOrderType("WAREHOUSE")}
                                                    >
                                                        Drop at Warehouse
                                                    </button>
                                                </div>
                                            </div>


                                            {/* <div className="col-12 col-md-6 ">

                                                <label className='form-label'>Select User*</label>




                                                <select
                                                    required
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='userId'
                                                    value={userId}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setUserId(selectedId);

                                                        const selectedUser = orderUsers?.find(
                                                            (user) => String(user.id) === selectedId
                                                        );
                                                        setSelectedUser(selectedUser);
                                                    }}
                                                >
                                                    <option value=""> Select User</option>


                                                    {userId && selectedUser && (
                                                        <option value={userId}>
                                                            {selectedUser.fullname}
                                                        </option>
                                                    )}


                                                    {orderUsers?.map((userInfo) => (
                                                        <option key={userInfo.id} value={userInfo.id}>
                                                            {`${userInfo?.fullname} - ${userInfo?.email}`}
                                                        </option>
                                                    ))}
                                                </select>


                                            </div> */}

                                            <div className="col-12 col-md-6">
                                                <label className='form-label'>Select User*</label>

                                                <Select
                                                    className="react-select-custom "
                                                    options={userOptions}
                                                    value={selectedOption}
                                                    onChange={(selected) => {
                                                        setUserId(selected?.value || "");
                                                        const selectedUser = orderUsers?.find(user => String(user.id) === String(selected?.value));
                                                        setSelectedUser(selectedUser);
                                                    }}
                                                    placeholder="Select User"
                                                    getOptionLabel={(option) => option.label}
                                                    formatOptionLabel={(option, { context }) =>
                                                        context === "menu" ? option.label : option.shortLabel
                                                    }
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb", // border-neutral-200
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />

                                            </div>


                                            <div className="col-12 col-md-6" style={{ display: "flex", alignItems: "end" }}>





                                                <button
                                                    type='button'
                                                    className='btn text-primary-600 gap-2 bg-primary-light border border-primary-light-white px-18 py-8 d-flex align-items-center justify-content-center'
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"

                                                >
                                                    <Icon
                                                        icon="ic:baseline-plus"
                                                        className="icon text-xl line-height-1"
                                                    />
                                                    Create User
                                                </button>
                                            </div>


                                            {/* <div className="col-12 col-md-6 ">

                                                <label className='form-label'>Select Category*</label>



                                                <select
                                                    required
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='categoryId'
                                                    value={categoryId}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setCategoryId(selectedId);
                                                    }}
                                                >
                                                    <option value=""> Select a Category </option>
                                                    {orderCategories?.map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>


                                            </div> */}

                                            {/* <div className="col-12 col-md-6">
                                                <label className="form-label">Select Category*</label>

                                                <Select
                                                    className="react-select-custom "
                                                    classNamePrefix="react-select"
                                                    options={categoryOptions}
                                                    value={selectedCategoryOption}
                                                    onChange={(selected) => {
                                                        setCategoryId(selected?.value || "");
                                                    }}
                                                    placeholder="Select a Category"
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb", 
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div> */}

                                            <div className="col-12 col-md-6">
                                                <label className="form-label">Select Categories*</label>

                                                <Select
                                                    isMulti
                                                    className="react-select-custom"
                                                    classNamePrefix="react-select"
                                                    options={categoryOptions}
                                                    value={selectedCategoryOptions}
                                                    onChange={(selected) => {
                                                        setSelectedCategoryOptions(selected); // Store selected options
                                                        setCategoryIds(selected.map((opt) => opt.value)); // Store only IDs
                                                    }}
                                                    placeholder="Select Categories"
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div>


                                            {/* <div className="col-12 col-md-6 ">

                                                <label className='form-label'>Select Sub Category*</label>



                                                <select
                                                    required
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='subCategoryId'
                                                    value={subCategoryId}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setSubCategoryId(selectedId);
                                                    }}
                                                >
                                                    <option value="">Select Sub Category </option>
                                                    {orderSubCategories?.map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>


                                            </div> */}


                                            {/* <div className="col-12 col-md-6">
                                                <label className="form-label">Select Sub Category*</label>

                                                <Select
                                                    className="react-select-custom "
                                                    classNamePrefix="react-select"
                                                    options={subCategoryOptions}
                                                    value={selectedSubCategoryOption}
                                                    onChange={(selected) => {
                                                        setSubCategoryId(selected?.value || "");
                                                    }}
                                                    placeholder="Select Sub Category"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div> */}
                                            <div className="col-12 col-md-6">
                                                <label className="form-label">Select Sub Categories*</label>

                                                <Select
                                                    isMulti
                                                    className="react-select-custom"
                                                    classNamePrefix="react-select"
                                                    isDisabled={categoryIds?.length === 0}
                                                    options={subCategoryOptions}
                                                    value={selectedSubCategoryOptions}
                                                    onChange={(selected) => {
                                                        setSelectedSubCategoryOptions(selected);
                                                        setSubCategoryIds(selected.map((opt) => opt.value));
                                                    }}
                                                    placeholder="Select Sub Categories"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div>

                                            <div>

                                                <label className='form-label'>Select type of shipment*</label>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <div
                                                        onClick={() => setSelectedShipType("AIR")}
                                                        style={{
                                                            border: isSelected("AIR") ? "1px solid #243E85" : "1px solid #EBEBEB",
                                                            background: isSelected("airplAIRane") ? "#F2F5FF" : "#FDFDFD",
                                                            padding: "10px",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Icon
                                                            icon="mdi:airplane"
                                                            width="35"
                                                            height="35"
                                                            color={isSelected("AIR") ? "#243E85" : "#999999"}
                                                        />
                                                    </div>

                                                    <div
                                                        onClick={() => setSelectedShipType("SHIP")}
                                                        style={{
                                                            border: isSelected("SHIP") ? "1px solid #243E85" : "1px solid #EBEBEB",
                                                            background: isSelected("SHIP") ? "#F2F5FF" : "#FDFDFD",
                                                            padding: "10px",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Icon
                                                            icon="mdi:cargo-ship"
                                                            width="35"
                                                            height="35"
                                                            color={isSelected("SHIP") ? "#243E85" : "#999999"}
                                                        />
                                                    </div>
                                                </div>




                                            </div>

                                            <div className='form-group text-end'>
                                                <button
                                                    onClick={nextStep}
                                                    type='button'
                                                    className='form-wizard-next-btn btn btn-primary-600 px-32'
                                                    disabled={
                                                        !orderType ||
                                                        !categoryIds ||
                                                        !subCategoryIds ||
                                                        !selectedUser ||
                                                        !selectedShipType
                                                    }
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset
                                        className={`wizard-fieldset ${currentStep === 2 && "show"} `}
                                    >

                                        <div className='row gy-3'>
                                            {/* <div className="col-12 col-md-6 ">

                                                <label className='form-label'>Select Package Sizes*</label>



                                                <select
                                                    required
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='packageId'
                                                    value={packageId}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setPackageId(selectedId);

                                                        if (selectedId === "custom") {
                                                            setSelectedOrderPackage(null);
                                                        } else {
                                                            const selectedPackage = orderPackage?.find(pkg => String(pkg.id) === selectedId);
                                                            setSelectedOrderPackage(selectedPackage);
                                                            setCustomWeight("");
                                                        }
                                                    }}
                                                >
                                                    <option value="">Select Package Size</option>
                                                    {orderPackage?.map((packageSize) => (
                                                        <option key={packageSize.id} value={packageSize.id}>
                                                            {`${packageSize?.size_name} - ${packageSize?.size_weight} KG `}
                                                        </option>
                                                    ))}
                                                    <option value="custom">Custom</option>
                                                </select>


                                            </div> */}


                                            <div className="col-12 col-md-6">
                                                <label className="form-label">Select Package Sizes*</label>

                                                <Select
                                                    className="react-select-custom "
                                                    classNamePrefix="react-select"
                                                    options={packageSizeOptions}
                                                    value={selectedPackageOption}
                                                    onChange={(selected) => {
                                                        const selectedId = selected?.value;
                                                        setPackageId(selectedId);

                                                        if (selectedId === "custom") {
                                                            setSelectedOrderPackage(null);
                                                            setCustomWeight(""); // Reset weight for custom
                                                        } else {
                                                            const selectedPkg = orderPackage?.find(pkg => String(pkg.id) === String(selectedId));
                                                            setSelectedOrderPackage(selectedPkg);
                                                            setCustomWeight(""); // Optional: reset custom if predefined selected
                                                        }
                                                    }}
                                                    placeholder="Select Package Size"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div>



                                        </div>



                                        {packageId === "custom" && (

                                            <>

                                                <div className='row gy-3 mt-0'>
                                                    <div className="col-12 col-md-6 ">
                                                        <label className='form-label'>Custom Weight (KG)*</label>

                                                        <input
                                                            type="number"
                                                            min={0.1}
                                                            step={0.1}
                                                            value={customWeight}
                                                            onChange={(e) => setCustomWeight(e.target.value)}
                                                            className="form-control border border-neutral-200 radius-8"
                                                            placeholder="Enter weight in KG"
                                                            required
                                                        />

                                                    </div>
                                                    <div className="col-12 col-md-6 ">

                                                        <label className='form-label '>Select Unit</label>
                                                        <select
                                                            className="form-control border border-neutral-200 radius-8"
                                                            value={customDimensionUnit}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setCustomDimensionUnit(value);         // for label display and backend
                                                                setIsInch(value === "inch");           // for conditional logic
                                                            }}
                                                            required
                                                        >
                                                            <option value="inch">Inch</option>
                                                            <option value="feet">Feet</option>
                                                        </select>

                                                    </div>

                                                    <div className=" col-12 col-md-4 col-lg-4">
                                                        <label className="form-label ">
                                                            Length (in {customDimensionUnit.toUpperCase()})
                                                        </label>
                                                        <input
                                                            type="number"
                                                            value={customLength}
                                                            onChange={(e) => setCustomLength(e.target.value)}
                                                            className="form-control border border-neutral-200 radius-8"
                                                            placeholder="Enter Length"
                                                            required
                                                        />
                                                    </div>

                                                    {/* Width */}
                                                    <div className=" col-12 col-md-4 col-lg-4">
                                                        <label className="form-label ">
                                                            Width (in {customDimensionUnit.toUpperCase()})
                                                        </label>
                                                        <input
                                                            type="number"
                                                            value={customWidth}
                                                            onChange={(e) => setCustomWidth(e.target.value)}
                                                            className="form-control border border-neutral-200 radius-8"
                                                            placeholder="Enter Width"
                                                            required
                                                        />
                                                    </div>

                                                    {/* Height */}
                                                    <div className=" col-12 col-md-4 col-lg-4">
                                                        <label className="form-label ">
                                                            Height (in {customDimensionUnit.toUpperCase()})
                                                        </label>
                                                        <input
                                                            type="number"
                                                            value={customHeight}
                                                            onChange={(e) => setCustomHeight(e.target.value)}
                                                            className="form-control border border-neutral-200 radius-8"
                                                            placeholder="Enter Height"
                                                            required
                                                        />
                                                    </div>



                                                </div></>)
                                        }


                                        {orderType === "DOORSTEP" &&


                                            < div className='row gy-3 mt-0'>
                                                {/* <div className="col-12 col-md-6 ">

                                                    <label className='form-label'>Select User Pickup Address*</label>



                                                    <select
                                                        required
                                                        className='form-control border border-neutral-200 radius-8'
                                                        id='pickupId'
                                                        value={pickupId}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            setPickupId(selectedId);
                                                        }}
                                                    >
                                                        <option value="">Pickup Address</option>
                                                        {orderPickupAddress?.map((packageSize) => (
                                                            <option key={packageSize.id} value={packageSize.id}>
                                                   

                                                                {`${packageSize?.address}   `}
                                                            </option>
                                                        ))}
                                                    </select>


                                                </div> */}
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label">Select User Pickup Address*</label>

                                                    <Select
                                                        className="react-select-custom "
                                                        classNamePrefix="react-select"
                                                        options={pickupAddressOptions}
                                                        value={selectedPickupOption}
                                                        onChange={(selected) => {
                                                            setPickupId(selected?.value || "");
                                                        }}
                                                        placeholder="Pickup Address"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                border: "1px solid #e5e7eb",
                                                                borderRadius: "8px",
                                                                boxShadow: "none",
                                                                minHeight: "38px",
                                                                '&:hover': {
                                                                    borderColor: "#d1d5db",
                                                                },
                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: "#000",
                                                            }),
                                                        }}
                                                    />
                                                </div>


                                                <div className="col-12 col-md-6" style={{ display: "flex", alignItems: "end" }}>





                                                    <button
                                                        type='button'
                                                        className='btn text-primary-600 gap-2 bg-primary-light border border-primary-light-white px-18 py-8 d-flex align-items-center justify-content-center'
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#addPickup"

                                                    >
                                                        <Icon
                                                            icon="ic:baseline-plus"
                                                            className="icon text-xl line-height-1"
                                                        />
                                                        Add Pickup Address
                                                    </button>
                                                </div>


                                            </div>
                                        }





                                        <div className='row gy-3 mt-0'>
                                            {/* <div className="col-12 col-md-6 ">

                                                <label className='form-label'>Select User Delivery Address*</label>



                                                <select
                                                    required
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='deliveryId'
                                                    value={deliveryId}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setDeliveryId(selectedId);
                                                    }}
                                                >
                                                    <option value="">Delivery Address</option>
                                                    {orderDeliveryAddress?.map((packageSize) => (
                                                        <option key={packageSize.id} value={packageSize.id}>


                                                            {`${packageSize?.address}   `}
                                                        </option>
                                                    ))}
                                                </select>


                                            </div> */}

                                            <div className="col-12 col-md-6">
                                                <label className="form-label">Select User Delivery Address*</label>

                                                <Select
                                                    className="react-select-custom"
                                                    classNamePrefix="react-select"
                                                    options={deliveryAddressOptions}
                                                    value={selectedDeliveryOption}
                                                    onChange={(selected) => {
                                                        setDeliveryId(selected?.value || "");
                                                    }}
                                                    placeholder="Delivery Address"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            minHeight: "38px",
                                                            '&:hover': {
                                                                borderColor: "#d1d5db",
                                                            },
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: "#000",
                                                        }),
                                                    }}
                                                />
                                            </div>



                                            <div className="col-12 col-md-6" style={{ display: "flex", alignItems: "end" }}>





                                                <button
                                                    type='button'
                                                    className='btn text-primary-600 gap-2 bg-primary-light border border-primary-light-white px-18 py-8 d-flex align-items-center justify-content-center'
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#addDelivery"


                                                >
                                                    <Icon
                                                        icon="ic:baseline-plus"
                                                        className="icon text-xl line-height-1"
                                                    />
                                                    Add Delivery Address
                                                </button>
                                            </div>


                                        </div>


                                        <div className='row gy-3 mt-0'>
                                            <div className="col-12 col-lg-6 ">
                                                <label className='form-label ' htmlFor='pickupDate'>
                                                    Pickup/Drop Date
                                                </label>


                                                <input
                                                    type="text"
                                                    id="pickupDate"
                                                    className='form-control border border-neutral-200 radius-8'
                                                    placeholder="Select a date"
                                                    onFocus={(e) => (e.target.type = "date")}
                                                    min={new Date().toISOString().split("T")[0]}
                                                    value={pickupDate}
                                                    onChange={(e) => setPickupDate(e.target.value)}
                                                    required
                                                />

                                            </div>


                                            <div className="col-12 col-lg-6">
                                                <label className='form-label ' htmlFor='pickupTime'>
                                                    Pickup/Drop Time

                                                </label>


                                                <input
                                                    type="text"
                                                    id="pickupTime"
                                                    placeholder="Select a time"
                                                    className='form-control border border-neutral-200 radius-8'
                                                    onFocus={(e) => (e.target.type = "time")}
                                                    value={pickupTime}
                                                    onChange={(e) => setPickupTime(e.target.value)}
                                                    required
                                                />

                                            </div>

                                            {/* Pick Up Type */}



                                        </div>







                                        <div className='mt-3 form-group d-flex align-items-center justify-content-end gap-8'>
                                            <button
                                                onClick={prevStep}
                                                type='button'
                                                className='form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32'
                                            >
                                                Back
                                            </button>
                                            <button
                                                onClick={nextStep}
                                                type='button'
                                                disabled={isStep2ButtonDisabled}
                                                className='form-wizard-next-btn btn btn-primary-600 px-32'

                                            >
                                                Next
                                            </button>
                                        </div>
                                    </fieldset>
                                    <fieldset
                                        className={`wizard-fieldset ${currentStep === 3 && "show"} `}
                                    >
                                        <div className='row gy-3'>
                                            <div className="col-12 col-lg-6 ">
                                                <label className='form-label ' htmlFor='pickupDate'>
                                                    Add Discount (Optional)
                                                </label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        id="additional_discount"
                                                        name="additional_discount"
                                                        // required
                                                        disabled={!selectedShipType}
                                                        className={`form-control border ${discountError ? 'border-danger' : 'border-neutral-200'} radius-8`}
                                                        placeholder='Enter Additional Discount'
                                                        value={additionalProperties?.additional_discount || ""}
                                                        onChange={(e) => {
                                                            const discount = parseFloat(e.target.value);
                                                            if (discount > amountToBePaid) {
                                                                setDiscountError("Discount cannot exceed amount to be paid.");
                                                            } else {
                                                                setDiscountError("");
                                                                setAdditionalProperties((prev) => ({
                                                                    ...(prev || {}),
                                                                    additional_discount: discount,
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {discountError && (
                                                    <small className="text-danger">
                                                        {discountError}
                                                    </small>
                                                )}
                                            </div>

                                            <div className="col-12 col-lg-6">
                                                <label className='form-label '>Select Payment Status</label>
                                                <select
                                                    className="form-control border border-neutral-200 radius-8"
                                                    value={paymentStatus}
                                                    onChange={(e) => setPaymentStatus(e.target.value)}
                                                    required
                                                >
                                                    <option value="MARK_PAID">Mark as Paid</option>
                                                    <option value="MARK_DUE">Mark as Due</option>
                                                    <option value="SEND_LINK">Send Link</option>

                                                </select>
                                            </div>


                                            {paymentStatus === "MARK_DUE" && (
                                                <div className="col-12 col-md-6 ">
                                                    <label className='form-label '>Due Date & Time</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control border border-neutral-200 radius-8"
                                                        value={dueDateTime}
                                                        onChange={(e) => setDueDateTime(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            )}

                                            {/* 
                                            <div className="col-12 col-md-6 ">
                                                <label className='form-label ' htmlFor='shipmentShip'>
                                                    Amount to be paid:
                                                </label>
                                                <input
                                                    disabled
                                                    type='text'
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='shipmentShip'
                                                    placeholder='Auto-calculated'
                                                    value={amountToBePaid || 0}
                                                    readOnly
                                                />
                                            </div> */}

                                        </div>

                                        <div className='row gy-3 mt-0'>



                                            {/* <div className="col-12 col-lg-12">
                                                <label className='form-label' htmlFor='insurance_value'>
                                                    Add Insurance Value (Optional)
                                                </label>

                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>

                                                    <input
                                                        type="number"
                                                        id="insurance_value"
                                                        name="insurance_value"
                                                        disabled={!selectedShipType}
                                                        // required
                                                        className='form-control border border-neutral-200 radius-8'
                                                        placeholder='Enter Insurance Value'
                                                        value={additionalProperties?.insurance_value}
                                                        onChange={(e) => {
                                                            let value = parseFloat(e.target.value);
                                                            let errorMessage = '';

                                                            if (isNaN(value) || value < 0) {
                                                                value = '';
                                                            }

                                                            if (uptoVal && value > uptoVal) {
                                                                errorMessage = `Insurance value cannot exceed $${uptoVal}`;
                                                            }

                                                            setAdditionalProperties((prev) => ({
                                                                ...(prev || {}),
                                                                insurance_value: e.target.value, 
                                                            }));

                                                            setInsuranceError(errorMessage);
                                                            setIsInsuranceApplied(false);
                                                        }}
                                                    />

                                                    <button
                                                        className={`btn d-flex align-items-center justify-center`}
                                                        type="button"
                                                        style={{
                                                            backgroundColor: '#243E85',
                                                            color: '#fff',
                                                            padding: '8px 12px',
                                                            border: 'none'
                                                        }}
                                                        disabled={!additionalProperties?.insurance_value ||
                                                            additionalProperties?.insurance_value <= 0 ||
                                                            (uptoVal && parseFloat(additionalProperties?.insurance_value) > uptoVal)}
                                                        onClick={async () => {
                                                            const value = parseFloat(additionalProperties?.insurance_value);
                                                            if (!isNaN(value) && value > 0 && (!uptoVal || value <= uptoVal)) {
                                                                await getInsuranceCharges(value);
                                                                setIsInsuranceApplied(true);
                                                                setInsuranceError(''); 
                                                            }
                                                        }}
                                                    >
                                                        <Icon
                                                            icon={isInsuranceApplied ? 'mdi:check-circle' : 'mdi:check-circle-outline'}
                                                            width="24"
                                                            height="24"
                                                            className='menu-icon'
                                                        />
                                                    </button>
                                                </div>

                                                {insuranceError && (
                                                    <small className="text-danger mt-1 d-block">
                                                        {insuranceError}
                                                    </small>
                                                )}

                                                {uptoVal && (
                                                    <small className="text-muted mt-1 d-block">
                                                        Secure your important or fragile packages to retrieve the
                                                        value in case of loss or damage done during delivery. We
                                                        charge a fee of {gstPercent || 0}% GST of the value you declare above
                                                        (added to the delivery cost) for this. Valid upto ${uptoVal}.
                                                    </small>
                                                )}
                                            </div> */}

                                            {/* <div className="col-12 col-md-6">
                                                <label className="form-label fw-semibold" htmlFor="insurance_charges">
                                                    Insurance Charges:
                                                </label>
                                                <input
                                                    disabled
                                                    type="text"
                                                    className="form-control border border-neutral-200 radius-8"
                                                    id="insurance_charges"
                                                    placeholder="No insurance applied"
                                                    value={
                                                        isInsuranceApplied && insuranceAmount > 0
                                                            ? `$${insuranceAmount.toFixed(2)}`
                                                            : "N/A"
                                                    }
                                                    readOnly
                                                />
                                                {isInsuranceApplied && insuranceCharges > 0 && (
                                                    <small className="text-muted mt-1 d-block">
                                                        {gstPercent}% GST on ${additionalProperties?.insurance_value}
                                                    </small>
                                                )}
                                            </div> */}




                                            <div className="col-12 col-md-6 ">
                                                <label className='form-label ' htmlFor='shipmentShip'>
                                                    Amount to be paid:
                                                </label>
                                                <input
                                                    disabled
                                                    type='text'
                                                    className='form-control border border-neutral-200 radius-8'
                                                    id='shipmentShip'
                                                    placeholder='Auto-calculated'
                                                    value={amountToBePaid || 0}
                                                    readOnly
                                                />
                                            </div>

                                        </div>
                                        <div className='form-group d-flex align-items-center justify-content-end gap-8 ' style={{ marginTop: "40px" }}>
                                            <button
                                                onClick={prevStep}
                                                type='button'
                                                className='form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32'
                                            >
                                                Back
                                            </button>
                                            <button
                                                onClick={nextStep}
                                                type='button'
                                                disabled={isStep3ButtonDisabled}
                                                className='form-wizard-next-btn btn btn-primary-600 px-32'
                                            >
                                                Next
                                            </button>
                                        </div>

                                    </fieldset>
                                    <fieldset
                                        className={`wizard-fieldset ${currentStep === 4 && "show"} `}
                                    >
                                        {selectedUser &&
                                            <div className="my-5 border border-neutral-300  radius-8 bg-light" style={{ padding: "15px" }}>
                                                <h5 className="fw-bold mb-3 text-primary-600">Invoice Summary</h5>
                                                <div className="row">
                                                    {/* User Info */}
                                                    <div className="col-md-6 mb-2"><strong>User:</strong> {selectedUser?.fullname || "--"}</div>
                                                    <div className="col-md-6 mb-2"><strong>Email:</strong> {selectedUser?.email || "--"}</div>

                                                    {/* Addresses */}

                                                    {orderType === "DOORSTEP" &&
                                                        <div className="col-md-6 mb-2"><strong>Pick Up Address:</strong> {
                                                            orderPickupAddress?.find(addr => addr.id == pickupId)?.address || "--"
                                                        }</div>}
                                                    <div className="col-md-6 mb-2"><strong>Delivery Address:</strong> {
                                                        orderDeliveryAddress?.find(addr => addr.id == deliveryId)?.address || "--"
                                                    }</div>

                                                    {/* Package Info */}
                                                    <div className="col-md-6 mb-2"><strong>Package Size:</strong> {
                                                        packageId === "custom"
                                                            ? "Custom"
                                                            : selectedOrderPackage?.size_name || "--"
                                                    }</div>
                                                    <div className="col-md-6 mb-2"><strong>Package Weight:</strong> {
                                                        packageId === "custom"
                                                            ? `${customWeight} KG`
                                                            : `${selectedOrderPackage?.size_weight} KG` || "--"
                                                    }</div>

                                                    <div className="col-md-6 mb-2"><strong>Dimensions (L×W×H):</strong> {
                                                        packageId === "custom"
                                                            ? `${customLength || "--"} x ${customWidth} x ${customHeight} ${customDimensionUnit?.toUpperCase()}`
                                                            : `${selectedOrderPackage?.size_length || "--"} x ${selectedOrderPackage?.size_width || "--"} x ${selectedOrderPackage?.size_height || "--"} ${selectedOrderPackage?.inch ? "In" : "Ft"}`
                                                    }</div>

                                                    {/* Pickup Info */}
                                                    <div className="col-md-6 mb-2"><strong>Pickup/Drop Date:</strong> {pickupDate || "--"}</div>
                                                    <div className="col-md-6 mb-2"><strong>Pickup/Drop Time:</strong> {pickupTime || "--"}</div>
                                                    <div className="col-md-6 mb-2"><strong>Order Type:</strong> {orderType || "--"}</div>

                                                    {/* Charges */}
                                                    <div className="col-md-6 mb-2"><strong>Shipment Type:</strong> {selectedShipType || "--"}</div>
                                                    <div className="col-md-6 mb-2"><strong>Additional Discount:</strong> ${additionalProperties?.additional_discount || 0}</div>
                                                    <div className="col-md-6 mb-2"><strong>Insurance Value:</strong> ${additionalProperties?.insurance_value || 0}</div>

                                                    {/* Total */}
                                                    <div className="col-md-12 mt-3">
                                                        <h6 className="text-end fw-bold">
                                                            Total Amount to be Paid: <span className="text-primary-600">${amountToBePaid || 0}</span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>}
                                        <div className='form-group d-flex align-items-center justify-content-end gap-8'>
                                            <button
                                                onClick={prevStep}
                                                type='button'
                                                className='form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32'
                                            >
                                                Back
                                            </button>
                                            <button
                                                type='submit'
                                                disabled={isCreatingOrder}
                                                className='form-wizard-submit btn btn-primary-600 px-32'
                                            >

                                                {isCreatingOrder ? "Creating Order.." : "Create Order"}
                                            </button>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                            {/* Form Wizard End */}
                        </div>
                    </div>
                </div>
            </div >


            {/*Create User */}

            <CreateUser handleCreateUser={handleCreateUser} formData={formData} handleChange={handleChange} formErrors={formErrors} />





            {/* Add Delivery Address  */}



            <CreateDeliveryAddress handleCreateDeliveryAddress={handleCreateDeliveryAddress} setPickupFormData={setPickupFormData} pickupFormData={pickupFormData} handlePickupChange={handlePickupChange} pickupFormErrors={pickupFormErrors} />


            {/* Add Pickup Address  */}

            <CreatePickupAddress handleCreatePickUpAddress={handleCreatePickUpAddress} setPickupFormData={setPickupFormData} pickupFormData={pickupFormData} pickupFormErrors={pickupFormErrors} handlePickupChange={handlePickupChange} />

        </>
    );
};

export default AddOrderV3;
